// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnlockTwoToneSvg from "@ant-design/icons-svg/es/asn/UnlockTwoTone";
import AntdIcon from '../components/AntdIcon';

var UnlockTwoTone = function UnlockTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UnlockTwoToneSvg
  }));
};

UnlockTwoTone.displayName = 'UnlockTwoTone';
export default React.forwardRef(UnlockTwoTone);